import {IntermediatePart} from "../../parts/intermediatePart";

export default class WallB extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'wall_b';
    this.activeFeatureBeforeAllWalls = null;
    this.partName = 'Wall B';
    this.translateId = "visualizer.bathroom.walls.wall_b";
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new WallB());
  }

  setZIndex(zIndexes) {
    if(zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Wall_B;
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Wall_B;
      }
    }
  }

  // handleClick(clickFrom) {
  //   if (clickFrom === 'simpleWall' || clickFrom === 'showerWall' || clickFrom === 'vanityWall') {
  //     const parent = this.getParent();
  //     if (clickFrom === 'simpleWall') {
  //       parent.allWallsApplied = true;
  //     }
  //     parent.activeFeatureBeforeAllWalls = parent.activeFeature;
  //     if (!parent.placeholderChanged) {
  //       parent.rememberToRecoverPlaceholder = true;
  //     }
  //   }
  //   super.handleClick();
  // }

  // unCheckAllWalls(clickFrom, navPart) {
  //   if (clickFrom === 'simpleWall') {
  //     this.allWallsApplied = false;
  //   }
  //   if (!(navPart instanceof WallB)) {
  //     if (this.activeFeatureBeforeAllWalls) {
  //       this.activeFeatureBeforeAllWalls.handleClick();
  //       this.activeFeatureBeforeAllWalls = null;
  //     }
  //     if (this.rememberToRecoverPlaceholder) {
  //       this.placeholderChanged = false;
  //       this.rememberToRecoverPlaceholder = false;
  //     }
  //   }
  // }

}
